module.exports = __webpack_public_path__ + "static/media/comma-fill-curved.699ed96b.svg";